export const getFacetSectionKey = (facetName: string): string =>
	`facet:${facetName}`
